export default __webpack_public_path__ + "static/realWorldImg3-59c92fa6d20865f9b3c3b64041bc3e51.webp";